define('flight-components/mixins/withListings',[
  'App',
  'flight/lib/compose',
  'flight-components/mixins/withActions',
  'flight-components/mixins/withUrlState',
  'URIjs/URI'
],

function (App, compose, withActions, withUrlState, URI) {

  var withListings = function withListings() {

    compose.mixin(this, [withActions, withUrlState]);

    this.defaultAttrs({
      disclaimersToggleSelector: '.listing__disclaimers__toggle',
      disclaimersTextSelector: '.listing__disclaimers__text'
    });


    this.around('handleAction', function(superFn, ev) {
      ev.preventDefault();
      var $el = $(ev.target).closest('[data-action]');

      var $listingEl = $el.closest(this.attr.listingSelector);
      var listing = $listingEl.data();

      var listingAction = $el.data('action');

      if (typeof this[listingAction] === 'function') {
        this[listingAction](listing, $el);
      } else {
        throw new Error('Listing action `'+listingAction+'` does not exist.');
      }

    });


    this.toggleDisclaimers = function(listing, $el) {
      if (App.user.device.type === 'desktop') {
        $el.hide();
      }
      else {
        $el.closest('.listing').find('.listing__footer').hide();
        $el.closest('.listing').find('.middle__cta').addClass('reset__cta');
        $el.closest('.listing').find('.middle__cta button').css({width: 'auto'});
      }
      $el.closest('.listing').find(this.attr.disclaimersTextSelector).toggleClass('in');
    };


    this.printListing = function(listing) {
      this.trigger('uiPrintListingRequested', listing);
      window.print();
    };


    this.visitWebsite = function(listing) {
      this.trigger('uiNewWindowRequested', {url: listing.offerUrl});
    };


    this.viewListing = function(listing) {
      console.log('primary action on listing', listing);
    };


    this.doCouponCodeWindowSwap = function(listing) {
      // cpncode string is 3 values joined with `_`:
      // dataPartnerId, merchantId, offerId
      var cpncodeStr = [listing.dataPartnerId, listing.merchantId, listing.offerId].join('_');

      // use current url and append cpncode param
      // reopen current page in new window (passing along cpncode param)
      var winid = (new Date()).getTime();
      var codeWindow = window.open( URI(window.location.href).removeQuery('cpncode').removeQuery('dtmpg').addQuery({cpncode: cpncodeStr}).addQuery({dtmpg: App.dtmPage}), winid );

      this.openAffiliateUrl(listing, false);
    };


    this.openAffiliateUrl = function(listing, newWindow) {
      var newWindow = (typeof newWindow !== 'undefined') ? newWindow : true;

      // IMPORTANT - must append the vpref and content zone to the affiliate URL
      var affiliateUrl = URI(listing.offerUrl);
      affiliateUrl.addQuery({
        vprefid: App.user.cookies.vprefid,
        contentzoneid: this.getContentZone()
      });

      if (newWindow) {
        // reopen current page in new window (passing along cpncode param)
        window.open( affiliateUrl.toString() );
      } else {
        window.location = affiliateUrl.toString();
      }
    };


    this.showCouponCodeModal = function(ev, data) {
      var params = data.params.cpncode.split('_');
      var couponCodeUrl = URI('/merchantOffers');

      couponCodeUrl.addQuery({
        partnerId: params[0],
        merchantId: params[1],
        offerId: params[2]
      });

      this.activateModal({
        url: couponCodeUrl.toString(),
        attr: {
          id: this.attr.couponCodeDetailModalSelector
        }
      });
    };

    this.viewBppListingModal = function(ev, data) {

      if (data.params.printnow === 'false') return;

      var $el = $('[data-offer-id="' + data.params.offerId + '"]');
      var listing = $el.data();

      this.viewListing(listing);
    }

    this.getContentZone = function() {
      var url = URI(window.location.href);
      if (url.hasQuery('dtmpg')) {
        return url.search(true).dtmpg + ':modal';
      }
      return App.dtmPage;
    }


    this.after('initialize', function () {
      this.on('viewCouponCodeListing', this.showCouponCodeModal);
      this.on('viewBppListing', this.viewBppListingModal);

      // withUrlState mixin method to check
      // for page load state
      this.checkUrlState();
    });

  };

  return withListings;
});

